import { UploadModalComponent } from './../invoices-em/upload-modal/upload-modal.component';
import { RecuperarPassModalComponent } from './recuperarPassword/recuperarPass.component';
import { Component, OnInit, Input, Inject, ViewChild, ElementRef } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { NgbActiveModal, NgbModal, ModalDismissReasons, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { LoginObject } from '../../models/login-object';
import { AuthenticationService } from '../../services/authentication.service';
import { StorageService } from '../../services/storage.service';
import { Router } from '@angular/router';
import { Session } from '../../models/session';
import { timeout } from 'q';
import { TranslateService } from '@ngx-translate/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { count } from 'rxjs/operators';
import { CryptoService } from '../../security/crypto.service';
import { passwordValidator } from '../../shared/validators/password.validator';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [NgbActiveModal]
})
export class LoginComponent implements OnInit {
  @Input() idioma;
  @ViewChild('UploadModal') UploadModal: ElementRef;
  @ViewChild('popover') popover: NgbPopover | undefined; // popover de requisitos de contraseña

  public loginForm: FormGroup;
  public registerForm: FormGroup;
  public submitted: Boolean = false;
  public error = null;
  mensaje: any;
  badLogin = false;
  busy: boolean = false;
  sinSoporte: boolean = false; 
  dia;
  tarde;
  noche;
  activarReg: boolean = false;
  registro = {
    tipo: 'P',
    rfcUsuario: null,
    nombreUsuario: null,
    passUsuario: null,
    cpassUsuario: null,
    telefonoUsuario: null,
    direccionUsuario: null,
    correoUsuario: null,
  }
  registroInvalido: boolean = false;
  modalRespuesta;
  mensajeRespuesta: any;
  closeResult: string;

  modalReference;

  dLn;
  valueLn;
  msjErrorServidor;

  constructor(
    private translate: TranslateService,
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private storageService: StorageService,
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private router: Router,
    private cryptoService: CryptoService
  ) {
    this.activeModal.dismiss();
    this.activeModal.close(UploadModalComponent);
    this.storage.remove('LOCAL_STORAGE');
    const ln = window.navigator.language;
    this.valueLn = ln.substring(0, 2);
    translate.use(this.valueLn);
    this.storage.set('LOCAL_STORAGE', this.valueLn);
    this.translate.get('texto.mensajeErrorServidor').subscribe(
      text => {
        this.msjErrorServidor = text;
      });
    // this.validarNavegador();
  }

  validarNavegador() {
    // validacion de la version minima del navegador
    // El arreglo supportNav contiene las versiones minimas 
    // del navegador que seran aceptadas
    var supportNav = [
      {explorador: 'Opera', version: '41'},// 41.0.2
      {explorador: 'Chrome', version: '48'},// 48.0.2564.97
      {explorador: 'Safari', version: '3'},// 3.2.1
      {explorador: 'Firefox', version: '50'},// 50.0.2
      {explorador: 'Edge', version: '15'},// 15.15063
    ];
    ///////// Funcion con expresion regular para recuperar version del navegador /////////
    var getBrowserInfo = function() {
      var ua= navigator.userAgent, tem, 
        M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if(/trident/i.test(M[1])){
            tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE '+(tem[1] || '');
        }
        if(M[1]=== 'Chrome'){
            tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
            if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
        M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
        if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
        return M.join(' ');
    };
    /////////////////////////////////////////////////////////////////////////
    let versionFull = getBrowserInfo();
    let verSplit = versionFull.split(' ');

    if (versionFull.indexOf('IE') == 0) {
      this.sinSoporte = true; 
      alert(`Navegador: ${versionFull}\nAtención, el portal no cuenta con soporte para Internet explorer, le recomendamos cambiar su navegador`);
    }
    supportNav.forEach(element => {
       if (element.explorador == verSplit[0]) {
        if (verSplit[1] < element.version) {
          this.sinSoporte = true;
          alert(`Navegador: ${versionFull}\nAtención, el portal no cuenta con soporte para la versión de Explorador en la que se intenta acceder, le recomendamos actualizar su navegador, para el correcto funcionamiento del sistema`);
        }
       }
    });
  }

  ngOnInit() {
    this.hideModal();
    this.activeModal.dismiss();
    this.activeModal.close(UploadModalComponent);

    this.storageService.removeCurrentSession();

    this.cambiarMensaje();
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
    this.registerForm = this.formBuilder.group({
      rfc: ['', Validators.required],
      nombre: ['', Validators.required],
      contrasena: ['', [Validators.required, passwordValidator]],
      confcontrasena: ['', Validators.required],
      telefono: ['', Validators.required],
      direccion: ['', Validators.required],
      correo: ['', Validators.compose([Validators.required,
      Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$'),
      Validators.minLength(1)])]
    });
    this.registerForm.get('telefono').valueChanges.subscribe(value => { 
      if (value) {
        let valor = String(value)
        let cambiar = false;
        if (valor.includes(' ')) {
          valor = valor.split(' ').join('');
          cambiar = true;
        }
        if (valor.includes('-')) {
          valor = valor.split('-').join('');
          cambiar = true
        }
        if (valor.includes('(')) {
          valor = valor.split('(').join('');
          cambiar = true
        }
        if (valor.includes(')')) {
          valor = valor.split(')').join('');
          cambiar = true
        }
        // 
        value = valor;
        
        if (!Number(value)) {
          this.registerForm.get('telefono').setValue('')
        }else{
          if (cambiar) {
            this.registerForm.get('telefono').setValue(value);

          }
          
        }
      }
     })
  }
  
  useLanguage(event, language: string) {
    this.storage.remove('LOCAL_STORAGE');
    const selectElement = event.target;
    this.valueLn = selectElement.value;
    this.translate.use(this.valueLn);
    this.storage.set('LOCAL_STORAGE', this.valueLn);
    this.cambiarMensaje();
  }

  public hideModal() {
    if (this.UploadModal) {
      this.UploadModal.nativeElement.hide();
    } 
  }

  public submitLogin(): void {
    this.busy = true;
    this.submitted = true;
    this.error = null;
    if (this.loginForm.valid) {
      this.authenticationService.login(new LoginObject(this.loginForm.value), this.valueLn).subscribe(
        data => {
          this.busy = false;
          if (data != null) {
            // se guarda serverTime para sincronizar el reloj
            if (data.usuario && data.usuario.serverTime) this.cryptoService.setServerTime(data.usuario.serverTime);

            let session = {
              usuario: data.usuario,
              token: this.create_UUID()
            }
            this.correctLogin(session)
          } else {
            this.badLogin = true;
          }
        },
        error => {
          this.error = error;
          this.busy = false;
        }
      )
    }
  }

  private correctLogin(data: Session) {
    if (data != null) {
      this.storageService.setCurrentSession(data);
      this.router.navigate(['/home']);
      /* if (navigator.geolocation) {
        alert('siii');
       } else {
           alert("Tu navegador no soporta la geolocalización, actualiza tu navegador.");
       }  */
    } else {
    }
  }



  create_UUID() {
    var dt = new Date().getTime();
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
  }

  clearLogin() {
    this.badLogin = null;
  }
  cambiarMensaje() {
    const a = new Date();
    const hora = a.getHours();

    if (this.valueLn === 'en' || this.valueLn !== 'es') {
      if (hora >= 19 && hora <= 24) {
        this.mensaje = 'good evening!';
      } else if (hora >= 0 && hora <= 4) {
        this.mensaje = 'good morning!';
      } else if (hora >= 5 && hora <= 11) {
        this.mensaje = 'good morning!';
      } else if (hora >= 12 && hora <= 18) {
        this.mensaje = 'good afternoon!';
      }
    } else if (this.valueLn === 'es') {
      if (hora >= 19 && hora <= 24) {
        this.mensaje = 'buenas noches!';
      } else if (hora >= 0 && hora <= 4) {
        this.mensaje = 'buenos días!';
      } else if (hora >= 5 && hora <= 11) {
        this.mensaje = 'buenos días!';
      } else if (hora >= 12 && hora <= 18) {
        this.mensaje = 'buenas tardes!';
      }
    }

  }

  activarRegistro() {
    this.activarReg = !this.activarReg;
    this.limpiarCampos();
  }

  limpiarCampos() {
    this.registro = {
      tipo: 'P',
      rfcUsuario: '',
      nombreUsuario: '',
      passUsuario: '',
      cpassUsuario: '',
      telefonoUsuario: '',
      direccionUsuario: '',
      correoUsuario: '',
    }
  }

  recuperarPass() {
    const modalRef = this.modalService.open(RecuperarPassModalComponent, { size: 'sm', keyboard: false, centered: true, backdrop: 'static' }); 
    modalRef.componentInstance.idioma = this.valueLn;
  }

  submitRegister(respuesta) {
    if (this.registerForm.valid) {
      this.registroInvalido = false;
      this.busy = true;
      this.authenticationService.crearRegistro(this.registro,this.valueLn).subscribe(
        data => {
          this.busy = false;
          if (data != null) {
            
            this.mensajeRespuesta = data.respuesta.mensaje;
            this.openRespuesta(respuesta);

            if (data.respuesta.estatus == 'S') {
              this.activarReg = !this.activarReg;
              this.limpiarCampos();
            }

          } 
        },
        error => {
          this.busy = false;
          if (error.status === 500) {
            this.mensajeRespuesta = this.msjErrorServidor;
            this.openRespuesta(respuesta);
          } else {
            this.mensajeRespuesta = error.error.respuesta.mensaje;
            this.openRespuesta(respuesta);
          }

        }
      )

    } else {
      this.registroInvalido = true;
    }
  }

  openRespuesta(respuesta) {
    this.modalRespuesta = this.modalService.open(respuesta, { centered: true, keyboard: false, backdrop: 'static' });
    this.modalRespuesta.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  // validaciones de contraseña segura
  passwordHasError(errorKey: string): boolean {
    const passwordControl = this.registerForm.get('contrasena');
    if (!passwordControl || !passwordControl.errors) {
      return true; // no hay error
    }

    return !passwordControl.errors[errorKey];
  }

  get hasMinLength(): boolean { return this.passwordHasError('minLength') }
  get hasUppercase(): boolean { return this.passwordHasError('noUppercase') }
  get hasLowercase(): boolean {  return this.passwordHasError('noLowercase') }
  get hasNumber(): boolean {  return this.passwordHasError('noNumber') }
  get hasSpecialChar(): boolean { return this.passwordHasError('noSpecial') }

}



// WEBPACK FOOTER //
// ./src/app/pages/login/login.component.ts